import { Link } from "react-router-dom";

const points = [
  {
    icon: "ri-hand-heart-line",
    title: "每一部都亲测",
    desc: "小水团队逐集试看后才收录，不注水、不凑数，只把真正好看的三分钟短番放进清单。",
  },
  {
    icon: "ri-book-2-line",
    title: "按场景分好类",
    desc: "下饭、摸鱼、深夜、睡前……按你的真实看番场景归类，打开就能直接看，不用纠结。",
  },
  {
    icon: "ri-time-line",
    title: "短篇速刷不迷路",
    desc: "清晰标注集数与时长，一季总长一目了然，轻松计划一口气看完，绝不踩坑烂尾。",
  },
];

export default function AboutBlurb() {
  return (
    <section className="py-14 md:py-20">
      <div className="container-x grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
        <div>
          <span className="flex items-center gap-1.5 text-sm font-medium text-secondary-700">
            <i className="ri-heart-3-line"></i>
            关于小水看番
          </span>
          <h2 className="mt-3 font-heading text-2xl font-black leading-tight text-foreground-950 md:text-3xl">
            用短番装满每一段
            <span className="text-secondary-700">摸鱼时光</span>
          </h2>
          <p className="mt-4 text-base leading-relaxed text-foreground-600">
            小水看番是一群重度短番爱好者的内容推荐站。我们相信，好的三分钟短番就像一碗刚好的泡面——不占用太多时间，却能带来一整天的快乐。
          </p>
          <p className="mt-3 text-base leading-relaxed text-foreground-600">
            从泡面三分钟到一口气看完的合集，从下饭番到深夜治愈短篇，我们按口味认真分好类，帮你把宝贵的摸鱼时间花在真正值得看的番上。
          </p>
          <Link
            to="/about"
            className="btn-pill mt-7 bg-secondary-500 text-foreground-950 hover:bg-secondary-600"
          >
            了解我们 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 lg:grid-cols-1">
          {points.map((p) => (
            <div
              key={p.title}
              className="flex gap-4 rounded-2xl border border-background-200 bg-background-50 p-5"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-secondary-100 text-xl text-secondary-700">
                <i className={p.icon}></i>
              </span>
              <div>
                <h3 className="font-heading text-base font-bold text-foreground-950">{p.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-foreground-600">{p.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}